import { type ActionItem } from 'shared/ui'
import { type IUser } from 'entities/Users/model/types'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { type RowInbox } from 'entities/Inbox/model/Table/RowInbox'
import { makeInboxOwner } from './makeInboxOwner/makeInboxOwner'
import { removeFromInbox } from './removeFromInbox/removeFromInbox'

export const getMemberInboxActions = (
  member: IUser,
  inbox: RowInbox,
  entities: IEntitiesStore,
  onSuccess?: () => void | Promise<void>
): ActionItem[] => {
  const isOwner = inbox.owner?.id === member.id

  const actions: ActionItem[] = []

  if (!isOwner) {
    actions.push(
      makeInboxOwner(member, inbox, entities, onSuccess),
      removeFromInbox(member, inbox, onSuccess)
    )
  }

  return actions
}
